<template>
  <div>
    <div v-if="subscriptionCheck('active')">
      <h2 class="title-style pt-3">
        <v-icon class="icon-style">
          mdi-account-check-outline
        </v-icon> Check Ins
      </h2>
      <v-card
        color="#fff"
        class="project-list-card"
      >
        <v-card-title class="filter-card">
          <v-row>
            <v-col
              cols="12"
              lg="4"
              md="5"
              sm="12"
            >
              <v-text-field
                v-model="search"
                :hint="isSearchAdded ? searchHint : ''"
                dense
                persistent-hint
                label="Search"
                append-icon="mdi-magnify"
                outlined
                @keyup.enter="handleSearch"
                @keydown.esc="clearHandleSearch"
              />
            </v-col>
          </v-row>
        </v-card-title>
        <p
          v-if="!isSearchAdded"
          class="info-text"
        >
          <v-icon>mdi-account-hard-hat-outline</v-icon> Indicates Project Work <span class="division-style"> | </span>
          <v-icon>mdi-account-wrench-outline</v-icon>Indicates Project Issue<span class="division-style"> | </span>
          <v-icon>mdi-tablet-cellphone</v-icon> Indicates Kiosks<span class="division-style"> | </span>
          <v-icon>mdi-swap-horizontal-bold</v-icon> Indicates Cost-Shift
        </p>
        <v-data-table
          :headers="headers"
          :items="contractCheckInsList"
          :search="search"
          disable-sort
          :footer-props="{
            'items-per-page-options': [10, 20, 30]
          }"
          :loading="updateProgress"
          :server-items-length="totalRecords"
          class="elevation-1 table-contracts"
          mobile-breakpoint="100"
          light
          :options.sync="options"
          :items-per-page="itemsPerPage"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.app_user.first_name }} {{ item.app_user.last_name }}
                <v-tooltip
                  v-if="dailyWorkHrLimitReached(item)"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      color="#C62828"
                      v-on="on"
                    >
                      mdi-alert
                    </v-icon>
                  </template>
                  <span>Exceeded Daily Work Hour Limit</span>
                </v-tooltip>
              </td>
              <td>{{ item.app_user.company.name }}</td>
              <td>
                <font v-if="item.app_user.worker_category !== null">
                  {{ item.app_user.worker_category.name }}
                </font>
                <font v-else>
                  N/A
                </font>
              </td>
              <td class="my-type-style">
                <v-chip
                  outlined
                  class="type"
                  color="#37474F"
                  dark
                >
                  {{ item.type }}
                </v-chip>
              </td>
              <td>
                <font v-if="item.budget !== null">
                  {{ item.budget.name }}
                </font>
                <font v-else>
                  N/A
                </font>
              </td>
              <td>
                <v-icon
                  v-if="item.checkin_method_type === 'cost-shift'"
                  color="#2E7D32"
                  small
                >
                  mdi-swap-horizontal-bold
                </v-icon>
                {{ item.checkin_time | convertToLocal }}
              </td>
              <td>
                <font v-if="item.checkin_kiosk !== null">
                  <v-icon
                    small
                  >
                    mdi-tablet-cellphone
                  </v-icon>
                  {{ item.checkin_kiosk.location_name }}
                </font>
                <font v-if="item.checkin_kiosk === null && item.checkin_method_type === 'cost-shift'">
                  N/A
                </font>

                <font v-if="item.checkin_kiosk === null && item.checkin_method_type !== 'cost-shift'">
                  {{ item.checkin_gate.name }}
                </font>
              </td>
              <td>
                <font v-if="item.checkout_time !== null">
                  {{ item.checkout_time | convertToLocal }}
                  <v-tooltip
                    v-if="item.manual_checkout === true"
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        color="#C62828"
                        v-on="on"
                      >
                        mdi-account-arrow-right
                      </v-icon>
                    </template>
                    <span>Checkout Was Done Manually</span>
                  </v-tooltip>
                </font>
                <font
                  v-else
                  class="My-checkout-time"
                >
                  Onsite*
                </font>
                <v-icon
                  v-if="item.checkout_method_type === 'cost-shift'"
                  color="#C62828"
                  small
                >
                  mdi-swap-horizontal-bold
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
        <br>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </div>
    <div v-else>
      <v-alert
        text
        prominent
        type="warning"
        color="#006883"
        border="left"
        class="alert-style"
      >
        Upgrade to Premium Version to view the CheckIns.
      </v-alert>
    </div>
  </div>
</template>

<script>
import spinner from 'src/views/dashboard/component/SpinnerCentre';
import moment from 'moment';
import global from 'src/mixins/global';

  export default {
    name: 'ContractCheckIns',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    mixins: [global],
    data () {
      return {
        search: null,
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'app_user.first_name' },
          { text: 'Company', value: 'company.name' },
          { text: 'Category', value: 'worker_category.name' },
          { text: 'Check-In Type', value: 'checkin_type' },
          { text: 'Check-In Item', value: 'budget.name' },
          { text: 'Check-In At', value: 'checkin_time' },
          { text: 'Check-In Gate', value: 'checkin_gate.name' },
          { text: 'Check-Out At', value: 'checkout_time' },
        ],
        updateProgress: false,
        options: {},
        itemsPerPage: 10,
        pageStart: 0,
      };
    },
    computed: {
      paginatedRecordsStructure () {
        return this.$store.getters['projects/getContractCheckIns'];
      },
      contractCheckInsList () {
        const records = this.paginatedRecordsStructure;
        return records.data;
      },
      totalRecords () {
        if (Object.keys(this.paginatedRecordsStructure).length > 0) {
          return this.paginatedRecordsStructure.total;
        }
        return 0;
      },
      isSearchAdded () {
        if (this.search === null || this.search === '') {
          return false;
        }
        return true;
      },
      searchHint () {
        return `Press Enter to filter by name: '${this.search}' or press ESC to clear.`;
      },
    },
    watch: {
      options: {
      async handler () {
        await this.paginatedCall();
      },
      deep: true,
    },
    },
    methods: {
      async getAllRecordsFromServer () {
        this.updateProgress = true;
        this.search = null;
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        await this.paginatedCall();
        this.updateProgress = false;
      },
      async getRecordsFromServer () {
        this.updateProgress = true;
        await this.$store.dispatch('projects/fetchContractCheckIns', {
          projectContractId: this.$route.params.contractId,
          params: {
            params: {
              name: this.search === '' ? null : this.search,
              limit: this.itemsPerPage,
              startPage: this.pageStart,
            },
          },
        }).catch(() => {
          this.updateProgress = false;
        });
        this.updateProgress = false;
      },
      dailyWorkHrLimitReached (checkInDetails) {
        const checkInTime = new Date(checkInDetails.checkin_time).getTime();
        if (checkInDetails.checkout_time === null) {
          const currentTime = new Date().getTime();
          var diff = currentTime - checkInTime;
          var hrDiff = Math.floor(diff / 3.6e6);
          if (checkInDetails.app_user.work_hours <= hrDiff) {
            return true;
          }
          return false;
        } else {
          const checkOutTime = new Date(checkInDetails.checkout_time).getTime();
          var totalWorkHrs = checkOutTime - checkInTime;
          var hours = Math.floor(totalWorkHrs / 3.6e6);
          if (checkInDetails.app_user.work_hours <= hours) {
            return true;
          }
          return false;
        }
      },
      async handleSearch () {
      this.options.page = 1;
      await this.paginatedCall();
    },
    async clearHandleSearch () {
      this.search = null;
      this.options.itemsPerPage = 10;
      this.options.page = 1;
      await this.paginatedCall();
    },
    async paginatedCall () {
      this.itemsPerPage = this.options.itemsPerPage;
      this.pageStart = this.options.page * this.itemsPerPage - this.itemsPerPage;
      this.getRecordsFromServer();
    },
    },
  };
</script>

<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC;
}
.v-data-table {
  background-color: #ECEFF1
}
.My-checkout-time {
  color:#2E7D32;
  font-weight: bold;
}
.my-type-style {
  text-transform: capitalize;
}
.filter-card {
  border: 1px solid #ccc !important;
  padding: 15px;
}
.table-contracts {
  border-radius: 0px !important;
  background: #fff;
  box-shadow: none !important;
  border: 1px solid #ccc;
  border-top: none;
}
.contract-list-card {
  box-shadow: none !important;
}
.table-contracts tbody tr:nth-of-type(even) {
  background: #fff !important;
}
.table-contracts tbody tr:nth-of-type(odd):hover {
  background: #fff !important;
}
.action-btn {
  background: #fff !important;
}
.table-top-border{
  border: 1px solid #ccc;
  border-bottom: none;
  background: #edf6f9;
}
.info-text {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  font-style: italic;
  color: #37474F;
  margin-left: 15px;
  margin-top: -20px;
}
</style>
